import loadable from '@loadable/component';

export const CyclingweeklySiteWrapper = loadable(
  () => import(/* webpackChunkName: "cyclingweekly-site" */ './CyclingweeklySiteWrapper'),
);
